import {Component, HostListener, OnInit} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {CookieService} from 'ngx-cookie-service';
import {UserService} from '../../services/user.service';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';
import {User} from '../../models/user.model';
import {Status} from '../../models/status.model';
import {TestingService} from '../../services/testing.service';
import {ExNotificationsService} from './ex-notifications.service';
import {NotificationsService} from '../../services/notifications.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  private user: User;
  public signinError = false;
  public disableBtn = false;
  public remoteAccessError = false;
  public disabledUserError = false;
  public forgotDiv = false;
  visible = false;
  public login = '';
  public password = '';
  loginOld = '';
  passwordNewRepeat = '';
  passwordNew = '';
  passwordOld = '';
  repeatError = false;
  public formGroup: FormGroup;
  valid = false;

  constructor(private userService: UserService,
              private cookieService: CookieService,
              private authService: AuthService,
              private router: Router,
              public notificationsService: NotificationsService,
              public testingService: TestingService,
              public TranslateModule: TranslateModule,
              public exNotificationsService: ExNotificationsService) {
  }

  @HostListener('paste', ['$event'])
  checkOnPaste(event) {
    const clipboardText: string = event.clipboardData.getData('Text');
    this.isValidPaste(clipboardText.split(''), event);
  }

  private isValidPaste(arrayChar: string[], event) {
    arrayChar.forEach(function (value) {
      const charCode = value.charCodeAt(0);
      if (charCode > 128 || charCode === 32) {
        event.preventDefault();
      }
    });
  }

  ngOnInit() {
    if (JSON.parse(localStorage.getItem('User')) != null
      && JSON.parse(localStorage.getItem('User')).testing != null) {
      if (JSON.parse(localStorage.getItem('User')).testing === true) {
        this.router.navigate(['/dashboard/testing']);
      }
    }
  }

  // Accept all keykodes except 32 (space)
  checkInput(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 128 || charCode === 32) {
      return false;
    }
    return true;
  }

  onSignin(form: NgForm) {
    this.signinError = false;
    this.disableBtn = true;
    // const login = form.value.login;
    // const password = form.value.password;
    this.notificationsService.clearNearNotification();

    this.authService.signIn(this.login, this.password).subscribe(
      (response: any) => {
        const data: any = response.body;
        let role: string;
        if (data.roles.indexOf('ROLE_ADMIN') > -1) {
          role = 'ROLE_ADMIN';
        } else if (data.roles.indexOf('ROLE_HEAD') > -1) {
          role = 'ROLE_HEAD';
        } else if (data.roles.indexOf('ROLE_PARTNER') > -1) {
          role = 'ROLE_PARTNER';
        } else if (data.roles.indexOf('ROLE_USER') > -1) {
          role = 'ROLE_USER';
        }

        this.user = new User(
          data.id,
          role,
          data.roles,
          data.fullName,
          data.language,
          data.access,
          data.testing,
          data.status,
          data.mainGroup,
          data.biometryRequired);

        if (!this.user.access) {
          this.remoteAccessError = true;
          this.authService.signOut();
          this.disableBtn = false;
        } else if (this.user.status === Status.INACTIVE.toString()) {
          this.disabledUserError = true;
          this.authService.signOut();
          this.disableBtn = false;
        } else {
          // 1A
          this.userService.setLocal(this.user);

          this.exNotificationsService.getExNotifications().subscribe(
            (res: any) => {
              if (res.status === 200) {
                const exNotif = res.body;
                const blockingNotifications = this.filterBlockingExNotifications(exNotif);
                if (blockingNotifications.length > 0) {
                  this.exNotificationsService.setExNotificationsList(blockingNotifications);
                  this.router.navigate(['/ex-notifications']);
                } else {
                  this.cookieService.deleteAll();
                  localStorage.setItem('Authenticated', 'true');
                  this.userService.setLocal(this.user);
                  this.storeInitialSidebarState();
                  this.notificationsService.getNearNotificationFromAPI();
                  this.router.navigate(['/']);
                }
              } else {
                if (this.user.testing) {
                  // отправить на тестирование
                  this.router.navigate(['/dashboard/testing']);
                } else {
                  this.cookieService.deleteAll();
                  localStorage.setItem('Authenticated', 'true');
                  this.storeInitialSidebarState();
                  this.notificationsService.getNearNotificationFromAPI();
                  this.router.navigate(['/']);
                }
              }
            },
            (error) => {
              this.disableBtn = false;

              this.cookieService.deleteAll();
              localStorage.setItem('Authenticated', 'true');
              this.storeInitialSidebarState();
              this.notificationsService.getNearNotificationFromAPI();
              this.router.navigate(['/']);
            }
          );
        }
      },
      () => {
        this.signinError = true;
        this.disableBtn = false;
        setTimeout(function () {
          this.signinError = false;
        }.bind(this), 3000);
      }
    );

    this.testingService.setQuestions(null);
    this.testingService.answeredQuestions.clear();
    this.testingService.setSelectedAllAnswers(false);
    this.testingService.setAnswersDone(false);
    this.testingService.setButtonLabel('Check answers');
  }

  onChange() {
    this.router.navigate(['/change-password']);
    // this.visible = !this.visible;
    // if(this.forgotDiv) {
    //   this.forgotDiv = !this.forgotDiv;
    // }
  }

  changePassword() {
    if(this.passwordNew.length < 6 || this.passwordNewRepeat.length <6) {
      this.valid = true;
    } else {
      this.valid = false;
      this.signinError = false;
      this.disableBtn = true;
      if(this.passwordNew !== this.passwordNewRepeat) {
        this.repeatError = true;
      } 
      if(this.passwordNew === this.passwordNewRepeat) {
        this.authService.changePass(this.loginOld, this.passwordOld, this.passwordNew).subscribe(
          (response: any) => {
            document.location.reload();
          },
          () => {
            this.signinError = true;
            this.disableBtn = false;
          }
        );
      }  
    }
  }

  onForgot() {
    this.forgotDiv = !this.forgotDiv;
  }

  private storeInitialSidebarState(): void {
    localStorage.setItem('NavBar', this.resolveInitialSidebarState());
  }

  private resolveInitialSidebarState(): string {
    if (window.innerWidth <= 1023) {
      return 'false';
    }
    return 'true';
  }

  private filterBlockingExNotifications(notifications: any[]): any[] {
    if (!notifications || !notifications.length) {
      return [];
    }
    return notifications.filter(notification => !this.isStandardDiscussionNotification(notification));
  }

  private isStandardDiscussionNotification(notification: any): boolean {
    return notification
      && notification.category === 'STANDARD_DISCUSSION'
      && notification.type === 'STANDARD_DISCUSSION_STARTED'
      && notification.action === 'OPEN_STANDARD_DISCUSSION';
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/auth/signin/signin.component.ts